module.exports = __webpack_public_path__ + "img/blockables-instructions-3.0e29a63c.png";